import React from "react";
import { ShieldCheck, Scale, Sparkles, Globe, Lock, BadgeCheck } from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "100% Fee-for-Service",
    body: "No brokerage commissions, no kickbacks, no hidden upside. You pay us — and only us — to act in your interest.",
  },
  {
    icon: Scale,
    title: "Unbiased Owner's Representative",
    body: "Our entire mandate is to be the unconflicted voice in the room. We don't sell property, manage funds, or list units.",
  },
  {
    icon: Sparkles,
    title: "Technical & Data-Driven",
    body: "Every recommendation is grounded in granular yield analysis, spatial economics, and municipal compliance data.",
  },
  {
    icon: Globe,
    title: "Global Reach, Local Insight",
    body: "A US base with deep London partnerships and vetted trade networks gives absentee owners genuine on-the-ground leverage.",
  },
  {
    icon: Lock,
    title: "Zero Client Fund Exposure",
    body: "We never custody capital. Vendor payments, deposits and rent flows remain entirely between you and licensed parties.",
  },
  {
    icon: BadgeCheck,
    title: "Discreet by Design",
    body: "Engagements are confidential, structured under written mandate, and reported through secure channels only.",
  },
];

export default function WhyUs() {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.28em] text-[#6E5A4E]">Why Dira Yanuar Rusdias LLC</span>
          <h2 className="font-serif-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#2B211A] leading-[1.05]">
            Trust, expertise, and
            <span className="italic text-[#8C735D]"> unbiased</span> representation.
          </h2>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D6CDBB] border border-[#D6CDBB]">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`why-item-${i}`}
                className="bg-[#F9F8F6] p-8 md:p-10 hover:bg-[#EFEBE4] transition-colors duration-500 group"
              >
                <Icon strokeWidth={1.25} className="w-8 h-8 text-[#8C735D] group-hover:text-[#2B211A] transition-colors" />
                <h3 className="font-serif-display text-2xl text-[#2B211A] mt-8">{it.title}</h3>
                <p className="mt-3 text-[#6E5A4E] leading-relaxed text-[15px]">{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
